import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBgCircleBlur = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 390,
	height: 641,
	viewBox: "0 0 390 641",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_f_mars_board)",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 195,
			cy: 291,
			r: 250,
			fill: "url(#paint0_linear_mars_board)"
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_f_mars_board",
		x: -155,
		y: -59,
		width: 700,
		height: 700,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "BackgroundImageFix",
				result: "shape"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 50,
				result: "effect1_foregroundBlur_mars_board"
			})
		]
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_mars_board",
		x1: -55,
		y1: 291,
		x2: 445,
		y2: 291,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#B5B3FF" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .25,
				stopColor: "#F98672"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#8C96FF"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .75,
				stopColor: "#83AAFF"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F67E80"
			})
		]
	})] })]
});
export default SvgBgCircleBlur;
